<script setup lang="ts">
import { CheckCircleIcon, XCircleIcon, InformationCircleIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/20/solid'

defineProps<{
  type: 'success' | 'error' | 'info' | 'warning' | 'neutral'
  isClosable?: boolean
}>()

defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div class="border rounded-md p-4" :class="[
    type === 'success' ? 'border-green-300 bg-green-50' : '',
    type === 'error' ? 'border-red-300 bg-red-50' : '',
    type === 'info' ? 'border-blue-300 bg-blue-50' : '',
    type === 'warning' ? 'border-yellow-300 bg-yellow-50' : '',
    type === 'neutral' ? 'border-gray-300 bg-gray-50' : ''
  ]">
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon v-if="type === 'success'" class="h-5 w-5 text-green-400" aria-hidden="true" />
        <XCircleIcon  v-else-if="type === 'error'" class="h-5 w-5 text-red-400" aria-hidden="true" />
        <InformationCircleIcon v-else-if="type === 'info' || type === 'neutral'" class="h-5 w-5" :class="type === 'info' ? 'text-blue-400' : 'text-gray-400'" aria-hidden="true" />
        <ExclamationTriangleIcon v-else-if="type === 'warning'" class="h-5 w-5 text-yellow-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p class="text-sm font-medium" :class="[
            type === 'success' ? 'text-green-800' : '',
            type === 'error' ? 'text-red-800' : '',
            type === 'info' ? 'text-blue-800' : '',
            type === 'warning' ? 'text-yellow-800' : '',
            type === 'neutral' ? 'text-gray-800' : ''
          ]">
          <slot></slot>
        </p>
      </div>
      <div v-if="isClosable" class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button @click="$emit('close')" type="button" class="inline-flex rounded-md p-1.5 text-gray-500 hover:bg-gray-200/50 focus:outline-none focus:ring-2 focus:ring-gray-600/50 focus:ring-offset-2 focus:ring-offset-gray-100/50">
            <XMarkIcon class="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>